export default "__VITE_ASSET__2c78a199__"